import { Accordion } from '@mui/material';
import { withStyles } from 'tss-react/mui';

import AccordionSummary from './Summary';
import AccordionDetails from './Details';

const styles = (theme, _, classes) => ({
  root: {
    width: '100%',
    boxShadow: 'none',

    '&:before': {
      display: 'none',
    },

    [`&.${classes.expanded}`]: {
      margin: 0,
    },
  },
  expanded: {},
});

export { AccordionSummary, AccordionDetails };

export default withStyles(Accordion, styles);
